<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left p-breadcrumbs">
          <breadcrumb :list="list"></breadcrumb>
        </div>

        <div class="nav-right is-flex">
          <router-link v-if="!$auth.check()" to="/login" class="nav-item">Login</router-link>
          <dropdown :animation="'ani-fade'" :visible="ddVisible" @clickOut="ddVisible = false" :position="['right', 'bottom', 'center', 'top']">
            <a :class="{ open: ddVisible }" v-if="$auth.check()" @click="ddVisible = !ddVisible" class="nav-item user-name"><i class="fa fa-user"></i>
              <span class="fa fa-caret-down menu-button" v-bind:class="{ open: ddVisible }"></span>
            </a>
            <div slot="dropdown" class="dialog no-padding">
            <aside class="menu">
              <ul class="menu-list">
                <li><a @click="logout"><span class="menu-icon fa fa-power-off"></span> Logout</a></li>
                <li><a @click="openChangePasswordsDialog()"><span class="menu-icon fa fa-shield"></span> Change Password</a></li>
              </ul>
            </aside>
            </div>
          </dropdown>
        </div>
      </nav>
      <change-password-modal :visible="cpdVisible" @close="closeCPD()"></change-password-modal>
    </div>
  </section>
</template>

<script>

import Breadcrumb from 'vue-bulma-breadcrumb'
import { mapGetters, mapActions } from 'vuex'
import Dropdown from '../vue-my-dropdown'
import ChangePasswordModal from '../../views/projects/modals/changePassword/ChangePasswordModal'

export default {
  data () {
    return {
      list: null,
      ddVisible: false,
      cpdVisible: false
    }
  },

  components: {
    Breadcrumb,

    Dropdown,
    ChangePasswordModal
  },

  props: {
    show: Boolean
  },

  computed: {
    ...mapGetters({
      pkginfo: 'pkg',
      sidebar: 'sidebar',
      codelink () {
        if (this.$route.meta && this.$route.meta.link) {
          return 'https://github.com/vue-bulma/vue-admin/blob/master/client/views/' + this.$route.meta.link
        } else {
          return null
        }
      },
      name () {
        return this.$route.name
      }
    })
  },

  methods: {
    ...mapActions([
      'toggleSidebar'
    ]),
    closeCPD () {
      this.cpdVisible = false
    },
    logout () {
      this.ddVisible = false
      this.$auth.logout({
        redirect: 'Login',
        makeRequest: false // TODO: check
        // params: {},
        // success: function () {},
        // error: function () {},
        // etc...
      })
    },
    openChangePasswordsDialog () {
      this.cpdVisible = true
    },
    getList () {
      let matched = this.$route.matched.filter(item => item.name)
      let first = matched[0]
      if (first && (first.name !== 'Home' || first.path !== '')) {
        matched = [{ name: 'Home', path: '/' }].concat(matched)
      }
      this.list = matched
    }
  },

  watch: {
    $route () {
      this.getList()
    }
  },

  created () {
    this.getList()
  }
}
</script>

<style lang="scss">
  @import '~bulma/sass/utilities/derived-variables';
  @import '../../../sass/fct/variables';

.app-navbar {
  .nav-left{
    margin-left: 280px;
  }
  position: fixed;
  min-width: 100%;
  z-index: 1;
  /*box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);*/

  .user-name {
    text-transform: capitalize;
  }

  .nav-right {
    padding-right: 20px;

    .menu-button {
      transform: translate(5px, 2px);
      padding-right: 5px;
      padding-left: 3px;

      &.open {
        color: #ffff00;
      }
    }
  }

  .container {
    margin: auto 10px;
  }

  a, span {
    font-weight: 600;
  }

  a.nav-item.is-active {
    color: #fff;
  }

  a {
    color: #dfe3ee;
    margin: 10px 0;
    border-radius: 3px;

    .menu-icon {
      margin-right: 3px;
      color: #3b5998;
      transform: translateY(3px);
    }

    &:hover {
      color: #fff;

      .menu-icon {
          color: $primary-yellow;
      }
    }

    &.nav-item {
      color: #fff;

      &:hover, &.open {
        color: $primary-grey
      }
    }
  }

  .menu {
    position: fixed;
    top: 50px;
    right: 17px;
    background-color: #fff;
    background-clip: padding-box;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .15);
    border-radius: 3px;
    box-shadow: 0 3px 8px rgba(0, 0, 0, .3);

    border-radius: 3px;

    &:before {
      content: "";
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 7px 7px 7px;
      border-color: transparent transparent #fff transparent;
      position: absolute;
      top: -6px;
      right: 10px;
    }

    .menu-list {
      li {
        margin: 5px 0;
        a {
          text-align: left;
          border-radius: 0px;
          color: #484848;
          &:hover {
            background: $primary-background;
            color: #fff;
          }
        }
      }
    }

  }

  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
  }
}

.p-breadcrumbs {
  padding-left: 30px;

  a {
    color: $primary-black;
  }

  li + li:before {
    color: $primary-grey !important;
  }

  span {
    color: $primary-grey;
  }
}

.hero {
  /*background-color: #146eb4;*/
  background: linear-gradient(to right, #7fe4f4 0%,#7fe4f4 25% , #4cb5e5 100%);
}

.hero-brand {
  .vue {
    margin-left: 10px;
    color: #36AC70;
  }
  .admin {
    color: #28374B;
  }
}
</style>
